'use strict';
const angular = require('angular');

export default angular.module('appApp.dropdown', [])
  .directive('dropdown', function() {
    return {
      template: require('./dropdown.html'),
      restrict: 'EA',
      link: function(scope, element, attrs) {}
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/dropdown/dropdown.directive.js